import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import BaseLayout from "./layout/BaseLayout";
import AuthorizedLayout from "./layout/AuthorizedLayout";
import AnonymousLayout from "./layout/AnonymousLayout";
import {RoutePath} from "./constants/RoutePath";
import LogOperation from "./pages/log/operation";
import DictManage from "./pages/dict/manage";
import AccountUserLogin from "./pages/account/user/login";
import AccountUserRegister from "./pages/account/user/register";
import AccountUserProfile from "./pages/account/user/profile";
import AccountUserSecurity from "./pages/account/user/security";
import AccountTenantProfile from "./pages/account/tenant/profile";
import AccountTenantMember from "./pages/account/tenant/member";
import AccountAppActivated from "./pages/account/app/activated";
import AccountAppMarket from "./pages/account/app/market";
import AccountAppManage from "./pages/account/app/manage";
import AccountDataGroupManage from "./pages/account/dataGroup/manage";
import AccountDepartmentManage from "./pages/account/department/manage";

import WorkflowDeputyList from "./pages/workflow/deputy/list";

// 邮件管理
import MailPropertiesList from "./pages/mail/properties/list";
import MailTemplateList from "./pages/mail/template/list";

// 微信管理
import WeChatApplicationList from "./pages/wechat/application";
import WeChatMessageTemplateList from "./pages/wechat/message/template";

import VMSVisitRequestInviteVisitor from './pages/vms/visitor-register/invite/visitor';
import VMSVisitRequestInviteConstruction from './pages/vms/visitor-register/invite/construction';
import VMSVisitRequestInviteShipping from './pages/vms/visitor-register/invite/shipping';
import VMSVisitRequestInviteSpecialVehicle from './pages/vms/visitor-register/invite/special-vehicle';
import VMSVisitRequestInviteEmployeeVehicle from './pages/vms/visitor-register/invite/employee-vehicle';

import VMSVisitRequestHistory from "./pages/vms/visitor-register/history";
import VMSVisitorManageCheckin from "./pages/vms/visitor-manange/checkin";
import VMSVisitorManageCheckinSign from "./pages/vms/visitor-manange/checkin/sign";
import VMSVisitorManageHistory from "./pages/vms/visitor-manange/history";
import VMSVisitorManageHistoryVisitor from "./pages/vms/visitor-manange/history/visitor";
import VMSVisitorManageHistoryConstruction from "./pages/vms/visitor-manange/history/construction";
import VMSVisitorManageHistoryShipping from "./pages/vms/visitor-manange/history/shipping";
import VMSVisitorManageHistoryNoTenant from "./pages/vms/visitor-manange/historyNoTenant";
import VMSVisitorManageCheckOut from "./pages/vms/visitor-manange/checkOut";
import VMSVisitorManageToday from "./pages/vms/visitor-manange/today";
import VMSVisitorManageBlacklist from "./pages/vms/visitor-manange/blacklist";
import VMSSystemManageVisitorType from "./pages/vms/system-manage/visitor/type";
import VMSVisitorCardList from "./pages/vms/system-manage/card/list";
import VMSVisitorDeviceList from "./pages/vms/system-manage/device/list";
import VMSPendingApprovalList from "./pages/vms/visitor-register/pending/register";
import VMSPendingCheckinList from "./pages/vms/visitor-register/pending/checkin";
import VMSSystemManageArea from './pages/vms/system-manage/area';

import ExosStaffQuery from './pages/exos/staff';

// 自助终端画面
import VMSSelfTerminalWelcome from "./pages/vms/self-terminal/welcome";

// 移动端画面
import VMSMobileWelcome from "./pages/vms/mobile/welcome";
import VMSMobileVisitorSelfRegister from "./pages/vms/mobile/visitor"
import VMSMobileEmployeeRegister from "./pages/vms/mobile/employeeRegister"


import VMSMobileEmployeeHome from "./pages/vms/mobile/employee/home";
import VMSMobileEmployeeLogin from "./pages/vms/mobile/employee/login";
import VMSMobileEmployeeApprove from "./pages/vms/mobile/employee/pending-approve";
import VMSMobileEmployeeHistory from "./pages/vms/mobile/employee/visitor-hisotry";
import VMSMobileVisitorHistory from "./pages/vms/mobile/visitorRegisterHisotry";


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    // 严格模式（Strict Mode）是 React 中的一种特殊的组件，它用于在开发模式下检测潜在的问题。
    // 当你将一个组件包裹在 <React.StrictMode> 标签中时，React 会对该组件及其子组件进行多次渲染，以检测潜在的问题。这些问题可能包括使用已废弃的 API、依赖不稳定的生命周期方法、以及在渲染过程中产生副作用等。
    // 严格模式的主要目的是帮助开发者发现和修复潜在的问题，以便在生产模式下运行的应用能够更加稳定和高效。然而，需要注意的是，严格模式只在开发模式下生效，在生产模式下不会产生任何影响。
    // 所以，也可以不用管这个问题。毕竟正式环境不会出现。
    // 如果想解决，只需要，移除 <React.StrictMode> 组件
    // <React.StrictMode>
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<App/>}>
                <Route element={<BaseLayout/>}>
                    <Route element={<AuthorizedLayout/>}>
                        <Route index element={<AccountUserProfile/>}/>
                        <Route path={RoutePath.LOG_OPERATION} element={<LogOperation/>}/>
                        <Route path={RoutePath.DICT_MANAGE} element={<DictManage/>}/>
                        <Route path={RoutePath.ACCOUNT_USER_PROFILE} element={<AccountUserProfile/>}/>
                        <Route path={RoutePath.ACCOUNT_USER_SECURITY} element={<AccountUserSecurity/>}/>
                        <Route path={RoutePath.ACCOUNT_TENANT_PROFILE} element={<AccountTenantProfile/>}/>
                        <Route path={RoutePath.ACCOUNT_TENANT_MEMBER} element={<AccountTenantMember/>}/>
                        <Route path={RoutePath.ACCOUNT_APP_ACTIVATED} element={<AccountAppActivated/>}/>
                        <Route path={RoutePath.ACCOUNT_APP_MARKET} element={<AccountAppMarket/>}/>
                        <Route path={RoutePath.ACCOUNT_APP_MANAGE} element={<AccountAppManage/>}/>
                        <Route path={RoutePath.ACCOUNT_DATA_GROUP_MANAGE} element={<AccountDataGroupManage/>}/>
                        <Route path={RoutePath.ACCOUNT_DEPARTMENT_MANAGE} element={<AccountDepartmentManage/>}/>

                        <Route path={RoutePath.WORKFLOW_DEPUTY_LIST} element={<WorkflowDeputyList/>}/>

                        {/*邮件管理*/}
                        <Route path={RoutePath.MAIL_PROPERTIES_LIST} element={<MailPropertiesList/>}/>
                        <Route path={RoutePath.MAIL_TEMPLATE_LIST} element={<MailTemplateList/>}/>

                        {/*微信管理*/}
                        <Route path={RoutePath.WECHAT_APPLICATION_LIST} element={<WeChatApplicationList/>}/>
                        <Route path={RoutePath.WECHAT_MESSAGE_TEMPLATE_LIST} element={<WeChatMessageTemplateList/>}/>

                        <Route path={RoutePath.VMS_VISITOR_REGISTER_INVITE_VISITOR}
                               element={<VMSVisitRequestInviteVisitor/>}/>
                        <Route path={RoutePath.VMS_VISITOR_REGISTER_INVITE_CONSTRUCTION}
                               element={<VMSVisitRequestInviteConstruction/>}/>
                        <Route path={RoutePath.VMS_VISITOR_REGISTER_INVITE_SHIPPING}
                               element={<VMSVisitRequestInviteShipping/>}/>
                        <Route path={RoutePath.VMS_VISITOR_REGISTER_INVITE_SPECIAL_VEHICLE}
                               element={<VMSVisitRequestInviteSpecialVehicle/>}/>
                        <Route path={RoutePath.VMS_VISITOR_REGISTER_INVITE_EMPLOYEE_VEHICLE}
                               element={<VMSVisitRequestInviteEmployeeVehicle/>}/>

                        <Route path={RoutePath.VMS_VISITOR_REGISTER_HISTORY} element={<VMSVisitRequestHistory/>}/>
                        <Route path={RoutePath.VMS_VISITOR_REGISTER_PENDING_REGISTER}
                               element={<VMSPendingApprovalList/>}/>
                        <Route path={RoutePath.VMS_VISITOR_REGISTER_PENDING_CHECKIN}
                               element={<VMSPendingCheckinList/>}/>
                        <Route path={RoutePath.VMS_VISITOR_MANAGE_CHECKIN} element={<VMSVisitorManageCheckin/>}/>
                        <Route path={RoutePath.VMS_VISITOR_MANAGE_HISTORY} element={<VMSVisitorManageHistory/>}/>
                        <Route path={RoutePath.VMS_VISITOR_MANAGE_HISTORY_VISITOR}
                               element={<VMSVisitorManageHistoryVisitor/>}/>
                        <Route path={RoutePath.VMS_VISITOR_MANAGE_HISTORY_CONSTRUCTION}
                               element={<VMSVisitorManageHistoryConstruction/>}/>
                        <Route path={RoutePath.VMS_VISITOR_MANAGE_HISTORY_SHIPPING}
                               element={<VMSVisitorManageHistoryShipping/>}/>
                        <Route path={RoutePath.VMS_VISITOR_MANAGE_BLACKLIST} element={<VMSVisitorManageBlacklist/>}/>
                        <Route path={RoutePath.VMS_SYSTEM_MANAGE_AREA} element={<VMSSystemManageArea/>}/>
                        <Route path={RoutePath.VMS_SYSTEM_MANAGE_VISITOR_TYPE} element={<VMSSystemManageVisitorType/>}/>
                        <Route path={RoutePath.VMS_VISITOR_CARD_LIST} element={<VMSVisitorCardList/>}/>
                        <Route path={RoutePath.VMS_VISITOR_DEVICE_LIST} element={<VMSVisitorDeviceList/>}/>
                        <Route path={RoutePath.VMS_VISITOR_MANAGE_HISTORY_NO_TENANT}
                               element={<VMSVisitorManageHistoryNoTenant/>}/>
                        <Route path={RoutePath.VMS_VISITOR_MANAGE_CHECKOUT} element={<VMSVisitorManageCheckOut/>}/>
                        <Route path={RoutePath.VMS_VISITOR_MANAGE_TODAY} element={<VMSVisitorManageToday/>}/>
                        <Route path={RoutePath.EXOS_STAFF_QUERY} element={<ExosStaffQuery/>}/>
                    </Route>
                    <Route element={<AnonymousLayout/>}>
                        <Route path={RoutePath.ACCOUNT_USER_LOGIN} element={<AccountUserLogin/>}/>
                        <Route path={RoutePath.ACCOUNT_USER_REGISTER} element={<AccountUserRegister/>}/>
                    </Route>
                    <Route path={RoutePath.VMS_VISITOR_MANAGE_CHECKIN_SIGN} element={<VMSVisitorManageCheckinSign/>}/>
                    {/*自助终端画面*/}
                    <Route path={RoutePath.VMS_SELF_TERMINAL_WELCOME} element={<VMSSelfTerminalWelcome/>}/>
                    {/*移动端画面*/}
                    <Route path={RoutePath.VMS_MOBILE_WELCOME} element={<VMSMobileWelcome/>}/>
                    <Route path={RoutePath.VMS_MOBILE_VISITOR_SELF_REGISTER} element={<VMSMobileVisitorSelfRegister/>}/>
                    <Route path={RoutePath.VMS_MOBILE_EMPLOYEE_REGISTER} element={<VMSMobileEmployeeRegister/>}/>

                    <Route path={RoutePath.VMS_MOBILE_EMPLOYEE_HOME} element={<VMSMobileEmployeeHome/>}/>
                    <Route path={RoutePath.VMS_MOBILE_EMPLOYEE_LOGIN} element={<VMSMobileEmployeeLogin/>}/>
                    <Route path={RoutePath.VMS_MOBILE_EMPLOYEE_APPROVE} element={<VMSMobileEmployeeApprove/>}/>
                    <Route path={RoutePath.VMS_MOBILE_EMPLOYEE_HISTORY} element={<VMSMobileEmployeeHistory/>}/>
                    <Route path={RoutePath.VMS_MOBILE_VISITOR_HISTORY} element={<VMSMobileVisitorHistory/>}/>

                    {/* Using path="*"" means "match anything", so this route
                acts like a catch-all for URLs that we don't have explicit
                routes for. */}
                    {/*<Route path="*" element={<NoMatch />} />*/}
                </Route>
            </Route>
        </Routes>
    </BrowserRouter>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();